import React from "react";
import EditableHTML from "@/components/EditableHTML";

/**
 * Mirrors what /packages/<slug> renders, fed by the PackagesManager form state.
 */
const PackagePreview = ({ pkg = {}, featuresText = "" }) => {
  const features = (pkg.features && pkg.features.length
    ? pkg.features
    : featuresText.split("\n").map((s) => s.trim()).filter(Boolean));

  return (
    <div className="bg-slate-950 text-slate-100 min-h-[500px] p-10" data-testid="package-preview">
      <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-6">
        ATC Equipment · /packages/{pkg.slug || "your-slug"}
      </div>

      <div className="grid lg:grid-cols-[1.1fr_1fr] gap-10 items-start">
        <div className="rounded-3xl overflow-hidden bg-slate-900/60 aspect-[4/3] border border-white/10">
          {pkg.image_url ? (
            <img src={pkg.image_url} alt={pkg.name || "package"} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-slate-600 text-sm">
              No image yet
            </div>
          )}
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-atc-green mb-3">Equipment package</div>
          <h1 className="font-display font-black text-4xl text-white tracking-tight leading-[1.05]">
            {pkg.name || "Untitled package"}
          </h1>
          <div className="mt-4 flex items-baseline gap-3">
            <span className="text-2xl font-display font-bold chrome-gradient-text">{pkg.price || "Request a Quote"}</span>
            {!pkg.is_active && (
              <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-slate-700/30 text-slate-400">Hidden</span>
            )}
          </div>
          {pkg.short_description && (
            <p className="mt-5 text-slate-300 leading-relaxed">{pkg.short_description}</p>
          )}

          {features.length > 0 && (
            <ul className="mt-6 space-y-2 text-sm text-slate-300">
              {features.map((f, i) => (
                <li key={i} className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-atc-green shrink-0" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          )}

          <button type="button" className="mt-8 px-6 py-3 rounded-full text-sm font-semibold text-white brand-gradient">
            Request a Quote
          </button>
        </div>
      </div>

      {pkg.description_html && (
        <div className="mt-12 max-w-3xl">
          <h2 className="font-display font-bold text-2xl text-white mb-4">Details</h2>
          <EditableHTML html={pkg.description_html} className="text-slate-200 leading-relaxed prose-styled" />
        </div>
      )}
    </div>
  );
};

export default PackagePreview;
